import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleVerticalBarChartComponent } from './simple-vertical-bar-chart.component';
import { FuseSharedModule } from '../../../../../../../../../../@fuse/shared.module';
import { BarChartModule, ChartCommonModule } from '@swimlane/ngx-charts';
import { UtilsModule } from '../../../../../../../../../utils/utils.module';

@NgModule({
    declarations: [SimpleVerticalBarChartComponent],
    imports: [
        FuseSharedModule,
        CommonModule,
        BarChartModule,
        UtilsModule,
        ChartCommonModule
    ]
})
export class SimpleVerticalBarChartModule {
}
